export default {
  "HitPaw Online Audio Extractor": "HitPaw Онлайн Аудио Экстрактор",
  "Extract sound from videos with ease.": "Извлекайте звук из видео с легкостью.",
  "Select Audio Format": "Выберите Формат Аудио",
  "Extract Audio": "Извлечь Аудио",
  "Extracting Audio": "Извлечение Аудио",
  "Extracted Successfully": "Извлечено Успешно",
  "Extract New": "Извлечение Нового",
  "Extraction Failed": "Не Удалось Извлечь",
  "Format": "Формат",
};
